import { render, staticRenderFns } from "./AddEventType.vue?vue&type=template&id=c724d88c&"
import script from "./AddEventType.vue?vue&type=script&lang=js&"
export * from "./AddEventType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddEventType.vue"
export default component.exports